export const TIME_POINT_PLACEHOLDER = "--:--:--";

export const MOMENT_ERROR = "Invalid date";
